import { Injectable } from '@angular/core';
import { AppConfig } from '../../app.config';
import { HttpClient } from '@angular/common/http';
import { ProductsStatistics } from '../models/products-statistics';
import { ObjectResponse } from '../../core/models/object-response';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private _appConfig: AppConfig, private _httpClient: HttpClient) { }

  fetchProductsStatistics(): Observable<ObjectResponse<ProductsStatistics>> {
    return this._httpClient.get<ObjectResponse<ProductsStatistics>>(
      this._appConfig.apiEndpoint + 'dashboard/products-statistics'
    )
  }
}
